import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { createArtifactFeedsSyncActions } from './artifact-feeds.actions'
import { artifactFeedsInitialState } from './artifact-feeds.slice'
import type { ArtifactFeedsStore } from './artifact-feeds.type'

export const useArtifactFeedsStore = create<ArtifactFeedsStore>()(
  devtools(
    subscribeWithSelector(
      immer((set) => ({
        ...artifactFeedsInitialState,
        ...createArtifactFeedsSyncActions(set),
      }))
    ),
    {
      name: StoreDevtoolsName.ArtifactFeeds,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
